import StudentUpdatedPasswordPage from './StudentUpdatedPasswordPage';
import { StudentUpdatedPasswordPageProps, StudentUpdatedPasswordPageValueProps } from './types';

export type { StudentUpdatedPasswordPageProps, StudentUpdatedPasswordPageValueProps };
export default StudentUpdatedPasswordPage;
